module.exports = __webpack_public_path__ + "static/media/testimonial_img.e537ed27.png";